import { render } from "./PriceHistoryChart.vue?vue&type=template&id=7314cc43&scoped=true"
import script from "./PriceHistoryChart.vue?vue&type=script&lang=js"
export * from "./PriceHistoryChart.vue?vue&type=script&lang=js"

import "./PriceHistoryChart.vue?vue&type=style&index=0&id=7314cc43&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7314cc43"]])

export default __exports__